import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  feeDetailsReportsList: { loading: false, data: null, error: null },
  transportReportList:{loading: false, data: null, error: null},
  supplementaryReportList:{loading: false, data: null, error: null},
};

export const feeDetailsReportSlice = createSlice({
  name: "feeDetailsReports",
  initialState,
  reducers: {
    fetchFeeDetailsReportsListRequest: (state, action) => {
      state.feeDetailsReportsList.loading = true;
      state.feeDetailsReportsList.error = null;
    },
    fetchFeeDetailsReportsListSuccess: (state, action) => {
      state.feeDetailsReportsList.data = action.payload;
      state.feeDetailsReportsList.loading = false;
      state.feeDetailsReportsList.error = null;
    },
    fetchFeeDetailsReportsListFailure: (state, action) => {
      state.feeDetailsReportsList.data = null;
      state.feeDetailsReportsList.loading = false;
      state.feeDetailsReportsList.error = action.payload;
    },

      // for Transport fee deatil report
      fetchTransportDetailsReportsListRequest: (state, action) => {
        state.transportReportList.loading = true;
        state.transportReportList.error = null;
      },
      fetchTransportDetailsReportsListSuccess: (state, action) => {
        state.transportReportList.data = action.payload;
        state.transportReportList.loading = false;
        state.transportReportList.error = null;
      },
      fetchTransportDetailsReportsListFailure: (state, action) => {
        state.transportReportList.data = null;
        state.transportReportList.loading = false;
        state.transportReportList.error = action.payload;
      },

      //For Supplementary Fee details reports
      fetchSupplementaryDetailsReportsListRequest: (state, action) => {
        state.supplementaryReportList.loading = true;
        state.supplementaryReportList.error = null;
      },
      fetchSupplementaryDetailsReportsListSuccess: (state, action) => {
        state.supplementaryReportList.data = action.payload;
        state.supplementaryReportList.loading = false;
        state.supplementaryReportList.error = null;
      },
      fetchSupplementaryDetailsReportsListFailure: (state, action) => {
        state.supplementaryReportList.data = null;
        state.supplementaryReportList.loading = false;
        state.supplementaryReportList.error = action.payload;
      },

    
  },
});

export const {
  fetchFeeDetailsReportsListRequest,
  fetchFeeDetailsReportsListSuccess,
  fetchFeeDetailsReportsListFailure,

  fetchTransportDetailsReportsListRequest,
  fetchTransportDetailsReportsListSuccess,
  fetchTransportDetailsReportsListFailure,

  fetchSupplementaryDetailsReportsListRequest,
  fetchSupplementaryDetailsReportsListSuccess,
  fetchSupplementaryDetailsReportsListFailure,

} = feeDetailsReportSlice.actions;

export const getFeeDetailsReportsListState = (store) =>
  store.feeDetailsReports?.feeDetailsReportsList;

  export const getTransportDetailsReportsListState = (store) =>
  store.feeDetailsReports?.transportReportList;

  export const getSupplementaryDetailsReportsListState = (store) =>
  store.feeDetailsReports?.supplementaryReportList;

  


export default feeDetailsReportSlice.reducer;
